<template>
  <base-form :can-back="canBack">
    <slot />
    <template #submit-button>
      <send-button class="px-5" :disabled="doubleSend" />
    </template>
    <template #expansion-buttons-right>
      <slot name="expansion-buttons-right" />
    </template>
  </base-form>
</template>

<script>
import BaseForm from '@/views/templates/forms/BaseForm'
import SendButton from "@/views/molecules/buttons/SendButton";

export default {
  name: "SendForm",
  components: {
    BaseForm,
    SendButton,
  },
  props: {
    canBack: {
      type: Boolean,
      default: false
    },
    doubleSend: {
      type: Boolean,
      default: false
    },
  },
}
</script>
